function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "134",
  height: "43"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "90.769%",
  x2: "-38.331%",
  y1: "4.84%",
  y2: "71.968%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7%",
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51.2%",
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "76%",
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "107.724%",
  x2: "-130.67%",
  y1: "49.424%",
  y2: "49.424%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "40.9%",
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "77.5%",
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: "86.389%",
  x2: "-49.886%",
  y1: "17.814%",
  y2: "194.39%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: "-18.581%",
  x2: "42.275%",
  y1: "-54.528%",
  y2: "24.692%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "6.9%",
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "47.6%",
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80.1%",
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00F076"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M129.037 42.515H4.963C2.183 42.515 0 40.193 0 37.237V5.574C0 2.618 2.184.296 4.963.296h124.074c2.78 0 4.963 2.322 4.963 5.278v31.663c0 2.956-2.184 5.278-4.963 5.278z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.747 1.14c2.295 0 4.191 2 4.191 4.423v31.602c0 2.423-1.896 4.425-4.191 4.425H4.99c-2.295 0-4.192-2.002-4.192-4.425V5.563c0-2.422 1.897-4.424 4.192-4.424h124.757zm0-.844H4.99C2.196.296 0 2.72 0 5.563v31.602c0 2.95 2.196 5.267 4.99 5.267h124.757c2.794 0 4.99-2.317 4.99-5.267V5.563c0-2.844-2.196-5.267-4.99-5.267z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M47.308 11.041c0 .843-.2 1.58-.699 2.107-.599.632-1.297.948-2.196.948-.898 0-1.597-.316-2.195-.948-.6-.632-.899-1.37-.899-2.318s.3-1.685.899-2.317c.598-.632 1.297-.948 2.195-.948.4 0 .799.105 1.198.316.4.21.699.421.898.737l-.499.527c-.4-.527-.898-.737-1.597-.737-.599 0-1.197.21-1.597.737-.499.421-.698 1.053-.698 1.79 0 .738.2 1.37.698 1.792.5.42.998.737 1.597.737.699 0 1.198-.21 1.697-.737.3-.317.499-.738.499-1.265h-2.196v-.842h2.895v.421zm4.59-2.633h-2.694v2.001h2.495v.737h-2.495v2.002h2.695v.843h-3.494V7.67H51.9v.737zm3.294 5.583h-.798V8.408h-1.697V7.67h4.192v.738h-1.697v5.583zm4.591 0V7.67h.799v6.32h-.799zm4.192 0h-.798V8.408H61.48V7.67h4.092v.738h-1.697v5.583h.1zm9.482-.843c-.6.632-1.298.948-2.196.948-.898 0-1.597-.316-2.196-.948-.599-.632-.898-1.37-.898-2.318s.3-1.685.898-2.317c.599-.632 1.298-.948 2.196-.948.898 0 1.597.316 2.196.948.598.632.898 1.37.898 2.317 0 .948-.3 1.686-.898 2.318zm-3.793-.527c.4.422.998.738 1.597.738s1.197-.211 1.597-.738a2.612 2.612 0 00.698-1.79c0-.738-.2-1.37-.698-1.791-.4-.422-.998-.738-1.597-.738s-1.198.21-1.597.738a2.614 2.614 0 00-.699 1.79c0 .738.2 1.37.699 1.791zm5.789 1.37V7.67h.898l2.894 4.95V7.67h.799v6.32h-.799l-3.094-5.162v5.162h-.698zm-7.486 9.269c-2.395 0-4.291 1.897-4.291 4.53 0 2.528 1.896 4.53 4.291 4.53 2.396 0 4.292-1.896 4.292-4.53 0-2.739-1.896-4.53-4.292-4.53zm0 7.164c-1.297 0-2.395-1.16-2.395-2.74 0-1.58 1.098-2.738 2.395-2.738 1.298 0 2.396 1.053 2.396 2.739 0 1.58-1.098 2.739-2.396 2.739zm-9.282-7.163c-2.395 0-4.291 1.896-4.291 4.53 0 2.527 1.896 4.529 4.291 4.529 2.396 0 4.292-1.896 4.292-4.53 0-2.739-1.896-4.53-4.292-4.53zm0 7.163c-1.297 0-2.395-1.16-2.395-2.74 0-1.58 1.098-2.738 2.395-2.738 1.298 0 2.396 1.053 2.396 2.739 0 1.58-1.098 2.739-2.396 2.739zM47.607 24.63v1.896h4.292c-.1 1.053-.5 1.896-.998 2.423-.6.632-1.597 1.37-3.294 1.37-2.695 0-4.69-2.213-4.69-5.057 0-2.844 2.095-5.056 4.69-5.056 1.397 0 2.495.632 3.294 1.37l1.297-1.37c-1.098-1.054-2.495-1.896-4.491-1.896-3.593 0-6.687 3.16-6.687 6.952s3.094 6.952 6.687 6.952c1.996 0 3.393-.632 4.59-2.001 1.199-1.264 1.598-3.055 1.598-4.424 0-.422 0-.843-.1-1.16h-6.188zm45.312 1.475c-.4-1.054-1.398-2.844-3.593-2.844-2.196 0-3.993 1.79-3.993 4.53 0 2.527 1.797 4.529 4.192 4.529 1.896 0 3.094-1.264 3.493-2.002l-1.397-1.053c-.499.737-1.098 1.264-2.096 1.264s-1.597-.421-2.096-1.37l5.69-2.528-.2-.526zm-5.79 1.474c0-1.685 1.298-2.633 2.197-2.633.698 0 1.397.421 1.596.948l-3.792 1.685zm-4.69 4.32h1.896V18.73H82.44v13.167zm-2.994-7.69c-.5-.527-1.298-1.054-2.296-1.054-2.096 0-4.092 2.002-4.092 4.53 0 2.528 1.897 4.424 4.092 4.424.998 0 1.797-.527 2.196-1.053h.1v.632c0 1.685-.898 2.633-2.296 2.633-1.098 0-1.896-.842-2.096-1.58l-1.596.738c.499 1.158 1.696 2.633 3.792 2.633 2.196 0 3.992-1.37 3.992-4.635v-8.006h-1.796v.738zm-2.196 6.215c-1.297 0-2.395-1.16-2.395-2.74 0-1.58 1.098-2.738 2.395-2.738 1.298 0 2.296 1.159 2.296 2.739 0 1.58-.998 2.739-2.296 2.739zm24.353-11.693H97.11v13.167h1.897v-4.95h2.595c2.095 0 4.092-1.58 4.092-4.109 0-2.528-1.997-4.108-4.092-4.108zm.1 6.32h-2.695v-4.53h2.694c1.398 0 2.196 1.265 2.196 2.213-.1 1.159-.898 2.317-2.196 2.317zm11.477-1.896c-1.397 0-2.795.632-3.294 2.002l1.697.737c.4-.737.998-.948 1.697-.948.998 0 1.896.632 1.996 1.685v.106c-.3-.21-1.098-.527-1.896-.527-1.797 0-3.593 1.053-3.593 2.95 0 1.79 1.497 2.95 3.094 2.95 1.297 0 1.896-.633 2.395-1.265h.1v1.053h1.796v-5.056c-.2-2.317-1.896-3.687-3.992-3.687zm-.2 7.269c-.598 0-1.497-.316-1.497-1.16 0-1.052 1.098-1.369 1.996-1.369.799 0 1.198.211 1.697.422-.2 1.264-1.198 2.107-2.196 2.107zm10.48-6.953l-2.096 5.689h-.1l-2.196-5.689h-1.996l3.294 8.006-1.896 4.424h1.896l5.09-12.43h-1.996zm-16.767 8.427h1.896V18.731h-1.896v13.167z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M.4.527C.1.843 0 1.369 0 2v23.28c0 .633.2 1.16.499 1.475l.1.106L12.975 13.8v-.211L.399.527z",
  transform: "translate(9.98 7.67)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M16.967 18.224l-4.092-4.32v-.315l4.092-4.32.1.106 4.89 2.95c1.397.843 1.397 2.212 0 3.055l-4.99 2.844z",
  transform: "translate(9.98 7.67)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M17.067 18.119l-4.192-4.425L.399 26.862c.5.526 1.198.526 2.096.105l14.572-8.848",
  transform: "translate(9.98 7.67)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M17.067 9.27L2.495.527C1.597 0 .898.105.4.632l12.476 13.062 4.192-4.424z",
  transform: "translate(9.98 7.67)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M26.947 25.683l-14.471 8.638c-.799.527-1.497.422-1.996 0l-.1.106.1.105c.499.421 1.197.527 1.996 0l14.471-8.849z",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10.38 34.321c-.3-.316-.4-.842-.4-1.475v.106c0 .632.2 1.159.5 1.475v-.106h-.1zm21.558-11.587l-4.99 2.95.1.105 4.89-2.95c.698-.421.998-.948.998-1.475 0 .527-.4.948-.998 1.37z",
  opacity: ".12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.476 8.302l19.462 11.693c.598.421.998.843.998 1.37 0-.527-.3-1.054-.998-1.475L12.476 8.197c-1.398-.843-2.495-.21-2.495 1.475v.105c0-1.58 1.097-2.318 2.495-1.475z",
  opacity: ".25"
}))));